/**
 * @file turnera.js
 * @description Servicio para búsqueda de profesionales y gestión de turnos.
 * Consume los endpoints de /landing/* del monitoreo-api.
 */
import api from "./api";

const turneraService = {};

/**
 * @description Obtiene especialidades médicas disponibles
 * @returns {Promise<Array>}
 */
turneraService.getSpecialties = function () {
  return api.get("/landing/medicalSpecialties").then((res) => res.data);
};

/**
 * @description Busca médicos por especialidad, ciudad y obra social
 * @param {Object} params
 * @param {string} params.medicalSpecialties - ID de especialidad
 * @param {string} [params.city] - Ciudad
 * @param {string} [params.medicalInsurance] - Obra social
 * @returns {Promise<Object>}
 */
turneraService.getDoctors = function (params) {
  return api
    .get("/landing/doctors", {
      params: { ...params, populate: ["doctor", "institution"] },
    })
    .then((res) => res.data);
};

/**
 * @description Obtiene el perfil público de un médico para la turnera
 * @param {string} doctorId
 * @returns {Promise<Object>} nombre, matrícula, especialidades e instituciones
 */
turneraService.getDoctorProfile = function (doctorId) {
  return api
    .get(`/landing/doctors/${doctorId}/profile`)
    .then((res) => res.data);
};

/**
 * @description Obtiene slots disponibles de un médico
 * @param {string} doctorId
 * @returns {Promise<Array>}
 */
turneraService.getSlotsByDoctor = function (doctorId) {
  return api.get(`/landing/slots/${doctorId}/doctor`).then((res) => res.data);
};

/**
 * @description Obtiene slots de una agenda específica
 * @param {string} agendaId
 * @returns {Promise<Array>}
 */
turneraService.getSlotsByAgenda = function (agendaId) {
  return api.get(`/landing/slots/${agendaId}/agenda`).then((res) => res.data);
};

/**
 * @description Crea un turno
 * @param {Object} appointment
 * @returns {Promise<Object>}
 */
/**
 * @description Crea un turno usando el endpoint del dashboard
 * @param {Object} appointment
 * @returns {Promise<Object>}
 */
turneraService.createAppointment = function (appointment) {
  return api.post("/appointments", appointment).then((res) => res.data);
};

/**
 * @description Obtiene los turnos previos del paciente para armar "Mis médicos"
 * @param {string} patientId
 * @returns {Promise<Array>}
 */
/**
 * @description Mis médicos — deshabilitado temporalmente, sin endpoint disponible para paciente
 * @returns {Promise<Array>}
 */
turneraService.getMyDoctors = function () {
  return Promise.resolve([]);
};

export default turneraService;
